import { useMemo } from "react";
import { getItemStyle, ItemStyle } from "../../utils";
import { ItemProps } from "../types";
import { BaseItem } from "./BaseItem";
import { CardItem } from "./CardItem";
import { ExpandableProvider } from "../../expandable-context";
import { CardItemNew } from "./CardItemNew";
import { useIsNewItem } from "../../hooks";

export function Item(props: ItemProps) {
  const itemStyle = useMemo(
    () => getItemStyle(props.uischema),
    [props.uischema]
  );
  const isNew = useIsNewItem(props.path);

  if (itemStyle === ItemStyle.CARD) {
    return (
      <ExpandableProvider>
        {isNew ? <CardItemNew {...props} /> : <CardItem {...props} />}
      </ExpandableProvider>
    );
  }

  return <BaseItem {...props} />;
}
